module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (error) { 
__p+='\n    <ul class="formField__errorList">\n        <li>'+
((__t=( error.message ))==null?'':_.escape(__t))+
'</li>\n    </ul>\n';
 } 
__p+='\n';
}
return __p;
};
